import type { ReactNode } from "react";
import { useEffect } from "react";

import {
  AnalyticsEvent,
  useAnalyticsLogger,
  useSharedGlobalConfig,
  useUnauthUrlFields,
} from "@shared/hooks";
import { useLocation } from "@shared/react-router-dom";

interface Props {
  children: ReactNode;
  isUnauth?: boolean;
}

const PageViewLogger = ({ children, isUnauth }: Props) => {
  const { pathname } = useLocation();
  const logAnalyticsEvent = useAnalyticsLogger();
  const unauthUrlFields = useUnauthUrlFields();
  const { isEmerson } = useSharedGlobalConfig();

  const getEventName = () => {
    if (isUnauth) {
      return AnalyticsEvent.UNAUTH_PAGE_VIEW;
    } else if (isEmerson) {
      return AnalyticsEvent.EMERSON_PAGE_VIEW;
    }

    return AnalyticsEvent.STORE_PAGE_VIEW;
  };

  useEffect(() => {
    logAnalyticsEvent({
      eventName: getEventName(),
      payload: {
        ...unauthUrlFields,
        url: pathname,
      },
    });
  }, [pathname]);

  return <>{children}</>;
};

export { PageViewLogger };
